import { FaBullseye, FaGift, FaPen } from 'react-icons/fa';
import {
  CardGrid,
  Card,
  CardHeader,
  HeaderActions,
  IconButton,
  StatusBadge,
  ItemList,
  ItemRow,
  ItemText,
  LoadingState,
  CardMenu,
} from '../../../../components/ManagementCardGrid';
import { loyaltyTypesKeys } from '../../constants';
import { conditionSummary, rewardSummary } from '../../utils/programSummary';
import * as S from './styles';

const typeConfig = {
  [loyaltyTypesKeys.cashback]: { label: 'Cashback', bg: '#e8f5e9', color: '#2e7d32' },
  [loyaltyTypesKeys.pedidos]: { label: 'Qtd. de pedidos', bg: '#fff3e0', color: '#e65100' },
  [loyaltyTypesKeys.valor_acumulado]: { label: 'Valor acumulado', bg: '#e8f4fd', color: '#1565c0' },
};

function TypeBadge({ type }) {
  const config = typeConfig[type] || { label: type, bg: '#f0f0f0', color: '#555' };
  return (
    <S.TypeBadge $bg={config.bg} $color={config.color}>
      {config.label}
    </S.TypeBadge>
  );
}

export function Cards({ data, loading, edit, toggleStatus, onDelete }) {
  if (loading) {
    return <LoadingState>Carregando...</LoadingState>;
  }

  return (
    <CardGrid minWidth="260px">
      {data.map((program) => (
        <Card key={program.Id} $clickable={false}>
          <CardHeader>
            <div>
              <S.TitleRow>
                <S.ClickableTitle
                  onClick={() => edit(program)}
                  title="Clique para editar"
                >
                  {program.Nome}
                </S.ClickableTitle>
                <IconButton onClick={() => edit(program)} title="Editar fidelidade">
                  <FaPen size={10} />
                </IconButton>
              </S.TitleRow>
              <S.TypeBadgeRow>
                <TypeBadge type={program.Tipo} />
              </S.TypeBadgeRow>
            </div>
            <HeaderActions>
              <StatusBadge
                $active={!!program.Status}
                onClick={() => toggleStatus(program)}
                title={program.Status ? 'Clique para desativar' : 'Clique para ativar'}
              >
                {program.Status ? 'Ativo' : 'Inativo'}
              </StatusBadge>
              <CardMenu
                options={[
                  { label: 'Editar', onClick: () => edit(program) },
                  {
                    label: program.Status ? 'Desativar' : 'Ativar',
                    onClick: () => toggleStatus(program),
                  },
                  {
                    label: 'Excluir',
                    danger: true,
                    onClick: () => onDelete(program),
                  },
                ]}
              />
            </HeaderActions>
          </CardHeader>

          <ItemList>
            <ItemRow>
              <ItemText>
                <FaBullseye size={11} />
                {conditionSummary(program)}
              </ItemText>
            </ItemRow>
            <ItemRow>
              <ItemText>
                <FaGift size={11} />
                {rewardSummary(program)}
              </ItemText>
            </ItemRow>
          </ItemList>
        </Card>
      ))}
    </CardGrid>
  );
}
